import React, { useState, useEffect } from 'react';

import Axios from 'axios';
import { Formik, Field } from 'formik';

import styled from 'styled-components';

import { validateAmountZeroAllowed } from '@libs/NwUtils';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { forceReloadProjectTransactions } from '@hooks/API/Project/UseProjectTransactions';
import { forceReloadTransaction } from '@hooks/API/UseTransaction';
import useConfigurations from '@hooks/Configurations/UseConfigurations';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwSaveButton } from '@components/Gui/NwButton';
import { NWInputNumber } from '@components/Gui/NwForm/NwFormItems';
import { NWSwitch } from '@components/Gui/NwForm/NwFormItems';
import { NwForm } from '@components/Gui/NwForm/NwFormWrapper';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

// const CommissionContainer = styled.div`
//     width: ${(props) => (props.commissionType === 'percentage' ? '130px' : '200px')};
//     margin-right: 16px;
//     .label {
//         margin-top: 2px;
//         margin-right: 8px;
//     }
//     .percentage {
//         margin-left: 4px;
//     }
//     .ant-input-number {
//         width: 100%;
//         font-size: 1.2rem;
//     }
// `;
const Wrapper = styled.div`
    .form-wrapper-line {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 1rem;
    }

    .commission-hint {
        font-size: 2.4rem;
        color: ${(props) => props.theme.TextColorMuted};
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 1rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
        margin-bottom: 1rem;

        .commission-texts {
            color: ${(props) => props.theme.TextColor};
            font-size: ${(props) => props.theme.FontSizeBase};
            .commission-default {
            }
            .fee-hint {
                margin-top: 0.5rem;
                font-weight: 600;
            }
        }
    }
`;

//TODO: ottimizzare props e rimuovere quelle inutili
const TransactionCommissionForm = ({
    type,
    transaction,
    contactID,
    currency,
    commission,
    statements,
    transactionId,
    onCancel,
    onUpdateTransaction,
    onTouchForm,
}) => {
    const [commissionType, setCommissionType] = useState(commission.TransactionPerc ? 'percentage' : 'amount');
    const [defaultTransaction, setDefaultTransaction] = useState();

    const configuration = useConfigurations();
    const defaultModelCommission = configuration.defaultAgencyCommissionPerc;
    const defaultAgencyFee = configuration.defaultAgencyFeePerc;
    const defaultMotherAgencyCommission = configuration.defaultMotherAgencyCommissionPerc;
    const defaultMotherAgencyCommissionOnGross = configuration.defaultMotherAgencyCommissionPercOnGross;

    const otherStatements = statements.filter((statement) => statement.ID !== commission.ID);
    let maxStatement = -1;
    for (const statement of otherStatements) {
        if (maxStatement < Math.abs(statement.Amount)) {
            maxStatement = Math.abs(statement.Amount);
        }
    }

    useEffect(() => {
        const fetchDefaultTransaction = async () => {
            try {
                const defaultTransaction = await Axios.get(
                    `/${type === 'model' ? 'models' : 'customers'}/GetDefaultTransactionData/${contactID}`
                );
                setDefaultTransaction(defaultTransaction);
            } catch (error) {
                console.error('Fetch Default Transaction Error => ', error);
            }
        };

        fetchDefaultTransaction();
    }, []);

    let initialValues = {
        Amount: Math.abs(commission.Amount),
        OnGross: type === 'agency' ? commission.TransactionPercOnGross : null,
        Percentage: commission.TransactionPerc,
    };

    const submitForm = async (values, setStatus, setSubmitting) => {
        setSubmitting(true);
        try {
            //TODO: gestire con condizioni varie tutti i casi:
            // percentage / amount, agencyfee / agencycommission / motheragencycommission (in base al tipo di soggetto)
            // utilizzare la family per comporre la chiamata
            // verificare operazione dopo salvataggio dati
            let urlcall = '';
            let data = {};

            data.TransactionID = transaction.ID;
            if (commissionType !== 'percentage') {
                data.Amount = values.Amount;
            } else {
                data.Perc = values.Percentage;
            }
            if (type === 'agency') {
                data.OnGross = values.OnGross;
            }

            switch (type) {
                case 'model':
                    if (commissionType !== 'percentage') {
                        urlcall = `/transactions/${transaction.Family}/modifyagencycommissionamount`;
                    } else {
                        urlcall = `/transactions/${transaction.Family}/modifyagencycommissionperc`;
                    }

                    break;
                case 'client':
                    if (commissionType !== 'percentage') {
                        urlcall = `/transactions/${transaction.Family}/modifyagencyfeeamount`;
                    } else {
                        urlcall = `/transactions/${transaction.Family}/modifyagencyfeeperc`;
                    }
                    break;
                case 'agency':
                    if (commissionType !== 'percentage') {
                        urlcall = `/transactions/${transaction.Family}/modifymotheragencycommissionamount`;
                    } else {
                        urlcall = `/transactions/${transaction.Family}/modifymotheragencycommissionperc`;
                    }
                    data.StatementID = commission.ID;
                    break;
                default:
                    break;
            }
            await Axios.put(urlcall, data);
            forceReloadTransaction(transaction.ID);
            if (transaction.ProjectID) {
                forceReloadProjectTransactions(transaction.ProjectID);
            }
            onTouchForm(false);
            onCancel();
            if (onUpdateTransaction) {
                onUpdateTransaction();
            }

            // if (commissionType === 'percentage') {
            //     await onUpdatePercentage({ type, transactionId, commissionId: commission.ID, percentage: values.Percentage });
            // } else {
            //     await onUpdateAmount({ type, transactionId, commissionId: commission.ID, amount: values.Amount, commisionId: commission.ID })
            // }
            // onTouchForm(false);
            // await onUpdateTransaction();
            // onCancel();
        } catch (error) {
            console.error('Update commission error => ', error);
            setSubmitting(false);
        }
    };

    const validatePercentage = (value) => {
        if (value < 0) return 'It should be greater than 0';
        if (value > 100) return 'It should be lower than 100';
        const stringValue = value.toString();
        if (stringValue.length >= 6) {
            return 'It should be less than 6 numbers';
        }
        return null;
    };

    const validateAmount = (value) => {
        if (value < 0) return 'It should be greater than 0';
        if (maxStatement !== -1 && maxStatement < value) {
            return `It should be lower than ${maxStatement}`;
        }
        const stringValue = value.toString();
        if (stringValue.length >= 12) {
            return 'It should be less than 12 numbers';
        }
        return null;
    };

    const CommissionHint = () => {
        if (!defaultTransaction) return null;

        const { NetworkAgency } = defaultTransaction;
        const contactName = getContactName(contactID);

        const feeHint = NetworkAgency.FeeHint ? (
            <div className="fee-hint">Fee Hint: {NetworkAgency.FeeHint}</div>
        ) : null;

        switch (type) {
            case 'model': {
                const isDefaultModelCommission =
                    NetworkAgency.ModelCommission === null || NetworkAgency.ModelCommission === undefined;
                const modelCommission = isDefaultModelCommission
                    ? defaultModelCommission
                    : NetworkAgency.ModelCommission;

                return (
                    <div className="commission-hint">
                        <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                        <div className="commission-texts">
                            <div className="commission-default">
                                <strong>{contactName}</strong> has a default commission set to{' '}
                                <strong>
                                    {modelCommission}%{isDefaultModelCommission ? ' [default]' : ''}
                                </strong>
                            </div>
                            {feeHint}
                        </div>
                    </div>
                );
            }

            case 'client':
                if (NetworkAgency.AgencyFee) {
                    return (
                        <div className="commission-hint">
                            <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                            <div className="commission-texts">
                                <div className="commission-default">
                                    <strong>{contactName}</strong> has a default agency fee set to{' '}
                                    <strong>{NetworkAgency.AgencyFee}%</strong>
                                </div>
                                {feeHint}
                            </div>
                        </div>
                    );
                }
                return (
                    <div className="commission-hint">
                        <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                        <div className="commission-texts">
                            <div className="commission-default">
                                <strong>{contactName}</strong> has a default agency fee set to{' '}
                                <strong>{defaultAgencyFee}% (STANDARD)</strong>
                            </div>
                            {feeHint}
                        </div>
                    </div>
                );

            case 'agency':
                if (defaultTransaction.Agencies && defaultTransaction.Agencies.length > 0 && transaction.ModelID) {
                    const defaultAgency = defaultTransaction.Agencies.find(
                        (agency) => agency.ModelID === transaction.ModelID
                    );
                    if (defaultAgency) {
                        return (
                            <div className="commission-hint">
                                <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                                <div className="commission-texts">
                                    <div className="commission-default">
                                        <strong>{contactName}</strong> has a mother agency commission on{' '}
                                        <strong>{getContactName(defaultAgency.ModelID)}</strong> set to{' '}
                                        <strong>
                                            {defaultAgency.Percentage}%{defaultAgency.OnGross ? ' on gross' : ' on net'}
                                        </strong>
                                    </div>
                                    {feeHint}
                                </div>
                            </div>
                        );
                    }
                }
                if (NetworkAgency.MotherAgencyCommission) {
                    return (
                        <div className="commission-hint">
                            <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                            <div className="commission-texts">
                                <div className="commission-default">
                                    <strong>{contactName}</strong> has a default mother agency commission set to{' '}
                                    <strong>
                                        {NetworkAgency.MotherAgencyCommission}%
                                        {NetworkAgency.MotherAgencyCommissionOnGross ? ' on gross' : ' on net'}
                                    </strong>
                                </div>
                                {feeHint}
                            </div>
                        </div>
                    );
                }
                return (
                    <div className="commission-hint">
                        <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                        <div className="commission-texts">
                            <div className="commission-default">
                                <strong>{contactName}</strong> has a default mother agency commission set to{' '}
                                <strong>
                                    {defaultMotherAgencyCommission}%{' '}
                                    {defaultMotherAgencyCommissionOnGross ? ' on gross' : ' on net'} (STANDARD)
                                </strong>
                            </div>
                            {feeHint}
                        </div>
                    </div>
                );
            default:
                return (
                    <div className="commission-hint">
                        <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                        <div className="commission-texts">{feeHint}</div>
                    </div>
                );
        }
    };

    return (
        <Wrapper>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    submitForm(values, setStatus, setSubmitting);
                }}
            >
                {({ isSubmitting, values, handleSubmit }) => {
                    return (
                        <NwForm values={values} onTouchForm={onTouchForm} onFinish={handleSubmit} layout="vertical">
                            <div className="form-wrapper-line">
                                <CommissionHint />
                            </div>
                            <div className="form-wrapper-line">
                                <RadioButtonGroup
                                    value={commissionType}
                                    onChange={setCommissionType}
                                    options={[
                                        { label: 'Percentage', value: 'percentage' },
                                        { label: 'Amount', value: 'amount' },
                                    ]}
                                />
                            </div>
                            <FlexContainer fullWidth mg="24px 0 8px">
                                {`Set commission ${commissionType}`}
                            </FlexContainer>
                            <div className="form-wrapper-line">
                                {commissionType === 'percentage' ? (
                                    <>
                                        <Field
                                            component={NWInputNumber}
                                            // label="Percentage"
                                            name="Percentage"
                                            step={0.01}
                                            value={values.Percentage}
                                            validate={validatePercentage}
                                        />
                                        <div className="percentage">%</div>
                                        {type === 'agency' && (
                                            <>
                                                <Field
                                                    component={NWSwitch}
                                                    label=""
                                                    name="OnGross"
                                                    defaultChecked={values.OnGross ? true : false}
                                                    checked={Boolean(values.OnGross)}
                                                />
                                                <div className="on-gross">On Gross</div>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <div className="label">{currency}</div>
                                        <Field
                                            component={NWInputNumber}
                                            // label="Amount"
                                            name="Amount"
                                            step={0.01}
                                            value={values.Amount}
                                            validate={validateAmount}
                                        />
                                    </>
                                )}
                            </div>
                            <div className="form-wrapper-line">
                                <NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />
                            </div>
                        </NwForm>
                    );
                }}
            </Formik>
        </Wrapper>
    );
};

export default TransactionCommissionForm;
